


























































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Advantages extends Vue {
  name: 'Advantages';

  icon: string[] = ['far', 'check-square'];
}
